<script>
import Pagination from '../Pagination/Pagination.vue'
import ActionsMenu from '../ActionsMenu/ActionsMenu.vue'

export default {
  components: {
    Pagination,
    ActionsMenu
  },
  emits: ['pageChange', 'onAction'],
  props: {
    title: String,
    stripe: Boolean,
    columns: {
      type: Array,
      validator: (value) => {
        return value.every((column) => column.type !== 'icon' ? column.key && column.label : column.key)
      }
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableClasses: {
      type: Object,
      default: () => ({
        header: 'sedap-base-table__header'
      })
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    emptyText: {
      type: String,
      default: 'Não foram encontrados processos.'
    }
  },

  methods: {
    filterVisibleActions (actions) {
      // Undefined e null são validos
      return actions.filter(action => action.show !== false)
    }
  }
}
</script>

<template>
  <div class="sedap-base-table">
    <h3 class="sedap-base-table__title">{{ title }}</h3>
    <el-table
      :data="tableData"
      :stripe="stripe"
      :header-cell-class-name="tableClasses.header"
      :cell-class-name="tableClasses.row"
      :emptyText="emptyText"
    >
      <el-table-column
        v-if="column.type === 'icon'"
        v-for="(column, index) in columns"
        :key="`col-${column.key}-${index}`"
        :label="column.label"
        :width="column.width"
        :sortable="column.sortable"
        :align="column.align"
      >
        <template slot-scope="scope">
          <i v-if="!column.tooltip"
            :class="[scope.row[column.key], 'font-size-16px']"
            :style="{ color: (column.color && column.color(scope.row)) || '' }"
          >
          </i>
          <el-tooltip
            v-else
            :content="column.tooltip(scope.row)"
            effect="dark"
            placement="top"
            popper-append-to-body
          >
            <span>
              <i
                :class="[scope.row[column.key], 'font-size-16px']"
                :style="{ fontSize: '', color: (column.color && column.color(scope.row)) || '' }"
              >
              </i>
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(column, index) in columns"
        v-if="column.type !== 'icon' && column.key !== 'actions'"
        :key="`col-${column.key}-${index}`"
        :prop="column.key"
        :label="column.label"
        :width="column.width"
        :sortable="column.sortable"
        :align="column.align"
      />
      <el-table-column
        v-for="(column, index) in columns"
        v-if="column.key === 'actions'"
        :key="`actions-${column.key}-${index}`"
        :prop="column.key"
        :label="column.label"
        :width="column.width"
        :sortable="column.sortable"
        :align="column.align"
      >
        <template slot-scope="scope">
          <ActionsMenu
            :actions="filterVisibleActions(scope.row.actions)"
            :rowData="tableData[scope.$index]"
            @onAction="$emit('onAction', $event)"
          />
        </template>
      </el-table-column>
    </el-table>
    <slot name="pagination">
      <Pagination
        v-if="pagination.show"
        :pagination="pagination"
        @pageChange="$emit('pageChange', $event)"
      />
    </slot>
  </div>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Tables/BaseTable/BaseTable.vue